import { mdiBulletinBoard } from '@lumapps/lumx/icons';

export const WIDGET_COMMUNITY_LIST_TYPE = 'community-list';

export const WIDGET_COMMUNITY_LIST_ICON = mdiBulletinBoard;

export const WIDGET_COMMUNITY_LIST_EDITION_SCOPE = 'widget-community-list-edition';
